import React from "react";
import { analytics } from "../../services";
import CustomInput from "../../components/DesignSystem/CustomInput.jsx";
import MaskedInput from "../../components/DesignSystem/MaskedInput.jsx";
import { ReCaptcha, loadReCaptcha } from "react-recaptcha-v3";
import {
  Box,
  Card,
  CardHeader,
  CardBody,
  Link,
  Text,
  Button,
  Center,
  Alert,
  AlertIcon,
  AlertDescription,
} from "@chakra-ui/react";

class createAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: true,
      isLoading: false,
    };
  }
  componentDidMount() {
    // This is the only component that can have this called on mount since they are all mounted at the start
    if (this.props.currentStep !== 1) {
      return;
    }
    analytics.track("CreateAccount", "Wizard", { page: 1 });

    loadReCaptcha(this.props.appConfig.recaptchaKey);
    window.scrollTo(0, 0);

    if (window.innerWidth <= 970) {
      let input = document.getElementById("lastName");
      input.blur();
    }
  }

  onButtonContinue = () => {
    this.setState({ isLoading: true });
    this.props.onContinue();
    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 5000);
  };

  verifyCallback = (recaptchaToken) => {
    analytics.event("action/recaptchaVerifyCallback", {
      recaptchaToken: recaptchaToken,
    });
  };

  updateToken = () => {
    // you will get a new tokeclassn in verifyCallback
    this.recaptcha.execute();
  };

  render() {
    if (this.props.currentStep !== 1) {
      return null;
    }

    if (this.props.accountExist && this.state.isLoading) {
      this.setState({ isLoading: false });
    }

    const isButtonEnabled =
      this.props?.lastName?.length > 1 &&
      this.props?.ssn?.replace(/[^0-9]/g, "").length === 9 &&
      this.props?.dateOfBirth?.length > 9;

    return (
      <Box bg="#EBF9FF">
        <ReCaptcha
          sitekey={this.props.appConfig.recaptchaKey}
          action="createaccount"
          verifyCallback={this.props.verifyCallback}
        />{" "}
        <Center>
          <Card mt={10} mb={10} maxW={"480px"} boxShadow="xl" p={10}>
            <CardHeader pb={1}>
              <Text textStyle="t6" as="b" color="pb100">
                {" "}
                Enroll in online access
              </Text>
            </CardHeader>

            <CardBody>
              <Text textStyle="b2">
                First, we’ll use the information below to find your Republic
                Finance account.
              </Text>
              {this.props?.accountExist && (
                <Box>
                  <Alert mt={5} variant="error" status="error">
                    {" "}
                    <AlertIcon />
                    <Box>
                      <AlertDescription>
                        We couldn’t find your account. Double check that you
                        have typed your information correctly. If you need help,
                        call or visit your nearest branch.
                      </AlertDescription>
                    </Box>
                  </Alert>
                </Box>
              )}
              {this.props.isRegistered && (
                <Box>
                  <Alert mt={5} variant="error" status="error">
                    {" "}
                    <AlertIcon />
                    <Box>
                      <AlertDescription>
                        Looks like you're already enrolled.{" "}
                        <a
                          style={{
                            textDecoration: "underline",
                            color: "#0065E0",
                          }}
                          href="https://secure.republicfinance.com/apps/account/login"
                        >
                          Sign in
                        </a>{" "}
                        to access your account.
                      </AlertDescription>
                    </Box>
                  </Alert>
                </Box>
              )}
              <Box mt={8}>
                <label htmlFor="lastName" className="visually-hidden">
                  Last Name
                </label>
                <CustomInput
                  id="lastName"
                  type="letters"
                  name="lastName"
                  inputTitle="Last Name"
                  role="presentation"
                  alt="Lastname"
                  inputRef={this.lastNameInputRef}
                  isRequired
                  onChange={this.props.handleChange}
                  value={this.props.lastName}
                ></CustomInput>
              </Box>

              <Box mt={8}>
                <label htmlFor="ssn" className="visually-hidden">
                  Social Security Number
                </label>
                <MaskedInput
                  inputTitle="Social Security Number"
                  isRequired
                  toggleButton
                  id="ssn"
                  name="ssn"
                  type="ssn"
                  maxLength={11}
                  onChange={this.props.handleChange}
                  value={this.props.ssn}
                  showIcon
                ></MaskedInput>
              </Box>
              <Box maxW={"260px"} mt={8}>
                <label htmlFor="dateOfBirth" className="visually-hidden">
                  Date of Birth
                </label>
                <CustomInput
                  id="dateOfBirth"
                  type="date"
                  name="dateOfBirth"
                  placeholder="MM/DD/YYYY"
                  inputTitle="Date of Birth"
                  isRequired
                  description="mm/dd/yyyy"
                  onChange={this.props.handleChange}
                  value={this.props.dateOfBirth}
                ></CustomInput>
              </Box>
              <Text textStyle="b3" color="pg60" mt={8}>
                By continuing to enroll, you agree to Republic Finance’s{" "}
                <Text style={{ textDecoration: "underline" }} as="b">
                  <Link
                    isExternal
                    href="https://www.republicfinance.com/legal/privacy-policy"
                  >
                    Privacy Policy
                  </Link>
                </Text>{" "}
                and{" "}
                <Text style={{ textDecoration: "underline" }} as="b">
                  <Link
                    isExternal
                    href="https://www.republicfinance.com/legal/terms-of-use"
                  >
                    Terms of Use
                  </Link>
                </Text>
                .
              </Text>
            </CardBody>

            <Box>
              <Center>
                <Button
                  w="100%"
                  m={4}
                  mb={8}
                  onClick={() => {
                    this.onButtonContinue();
                  }}
                  isDisabled={!isButtonEnabled}
                  isLoading={this.state.isLoading}
                >
                  Continue
                </Button>
              </Center>
            </Box>
            <Box ml={5}>
              <Text textStyle={"b2"}>
                Already have an account?{" "}
                <Link
                  style={{ textDecoration: "underline", color: "#0065E0" }}
                  isExternal
                  href="https://www.republicfinance.com/welcome-back"
                >
                  {" "}
                  Sign In
                </Link>{" "}
              </Text>
            </Box>
          </Card>
        </Center>{" "}
      </Box>
    );
  }
}

export default createAccount;
